export default "__VITE_ASSET__BwF8R1nK__"